const { useContext } = require("react")
const { SideBarContext } = require("./SideBarContext")

const useSideBarContext = () => {
    const { sideBarHidden, setSidebarHidden } = useContext(SideBarContext);

    return { sideBarHidden, setSidebarHidden };
}

export default useSideBarContext;